import { cn } from '@/utils/tailwind';

const FunctionNameInput = ({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: string) => void;
}) => {
  return (
    <div
      className={cn(
        'inline-grid flex-shrink-0 grid-cols-1 grid-rows-1 rounded-md bg-background focus-within:border-brand'
      )}
    >
      <input
        className={cn(
          'col-[1] row-[1] border-none bg-transparent px-4 py-3 font-mono',
          'min-w-0 text-transparent caret-black outline-none placeholder:text-tertiary dark:caret-slate-200'
        )}
        size={1}
        name="value"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      <div
        className={cn(
          'col-[1] row-[1] border-none bg-transparent px-4 py-3 font-mono',
          'pointer-events-none'
        )}
      >
        {value}{' '}
      </div>
      {!value && (
        <span
          className={cn(
            'col-[1] row-[1] border-none bg-transparent px-4 py-3 font-mono',
            'pointer-events-none text-tertiary'
          )}
        >
          Function Name
        </span>
      )}
    </div>
  );
};

export default FunctionNameInput;
